import React, { useEffect, useState, useContext } from "react";
import LayoutDashboard from "../../Components/Layout/LayoutDashboard";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import MethodGet, { MethodPost } from "../../Config/Services";
import ModalImage from "react-modal-image";
import { Button, Grid, Tooltip } from "@material-ui/core";
import Spinner from "../../Complements/Spinner";
import SvjPayment from "../../Complements/Image/DetailSale/payment.svg";
import DataClient from "../../Complements/Image/DetailSale/DataClient.svg";
import ButtonBase from "@material-ui/core/ButtonBase";
import Hidden from "@material-ui/core/Hidden";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import ModalPayments from "../Sales/ModalPaymentsRest";
import ErrorIcon from "@material-ui/icons/Error";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import headerConfig from "../../Config/imageHeaders";
import Swal from "sweetalert2";
import fileDownload from "js-file-download";
import clienteAxios from "../../Config/Axios";
import PictureAsPdf from '@material-ui/icons/PictureAsPdf';
import EditIcon from "@material-ui/icons/Edit";
import MaterialTable from "material-table";
import ModalEditPayment from "../Sales/ModalEditPayment";
import AuthContext from "../../Context/autenticacion/authContext";
import useSelectProductsPerBrand from "../SelectOptions/SelectProductsPerBrand";
import SelectTypeSale from "../SelectOptions/SelectTypeSale";
import ChangeTypeSale from "../Sales/ChangeTypeSale";
import { TextField, InputAdornment } from "@material-ui/core";
import CropFreeIcon from "@material-ui/icons/CropFree";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingLeft: theme.spacing(11),
    paddingBottom: theme.spacing(1),
    paddingInlineEnd: theme.spacing(3),
    paddingRight: theme.spacing(1),
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    marginBlockEnd: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  input: {
    display: "none",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  paperDetalle: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  paperTitle: {
    background: "#9966cc",
  },
  formControl: {
    margin: theme.spacing(1),
    width: "100%",
  },
  papercard: {
    maxWidth: "auto",
    backgroundColor: "#fff",
  },
  image: {
    width: "200px",
    height: "250px",
  },
  ticketimage: {
    width: 100,
    height: 120,
    maxWidth: 100,
    maxHeight: 120,
  },
  img: {
    margin: "auto",
    display: "flex",
    maxWidth: "100%",
    maxHeight: "100%",
  },
  papercardtitle: {
    background: "#6f33ab",
    //background: '#9966cc',
    padding: 7,
    fontSize: "21pt",
    color: "white",
  },
  Tblpapercard: {
    padding: theme.spacing(3),
    margin: "auto",
    Width: "100%",
    backgroundColor: "#fff",
  },
  textStructure: {
    borderBottom: "1px solid grey",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
}));

export default function DetailsSales(props) {
  const { id } = props.match.params;
  const classes = useStyles();

  // Auth Context
  const authContext = useContext(AuthContext);
  const { usuario } = authContext;


  const [details, saveDetail] = useState([]);
  const [products, saveProducts] = useState([]);
  const [payments, savePayments] = useState([]);
  const [cargando, spinnerCargando] = useState(false);
  const [saleId, saveSaleId] = useState([]);
  const [sales, saveSale] = useState([]);
  const [data, setData] = useState({});
  const [r, setR] = useState(false);
  const [disableButton, setDisabledButton] = useState(false);
  const [image, setImage] = useState({
    urlPhoto: "https://pisouniversitario.com/template/images/page-404.jpg",
    image: "",
  });
  const [open, setOpen] = useState(false);
  const handleChangeImage = (e) => {
    setImage({
      ...image,
      urlPhoto: URL.createObjectURL(e.target.files[0]),
      image: e.target.files[0],
    });
  };

  const [openEdit, setOpenEdit] = useState(false);
  const [paymentToEdit, setPaymentToEdit] = useState(null);

  // Product Selection State
  const [typeProduct, setTypeProduct] = useState(0); // Default to 0 (None selected)
  const [barcode, setBarcode] = useState("");
  const [typeSale, setTypeSale] = useState(0);

  // States for Explicit Product Addition
  const [selectedProductData, setSelectedProductData] = useState(null);
  const [quantityToAdd, setQuantityToAdd] = useState(1);
  const [priceToAdd, setPriceToAdd] = useState(0);

  useEffect(() => {
    if (sales.type_sale && typeSale === 0) {
      setTypeSale(sales.type_sale);
    }
  }, [sales]);

  // New hook for product selection
  const [productID, SelectProduct, productsList] = useSelectProductsPerBrand({
    stateInicial: "",
    branchID: sales.branch_office_id,
    typeSale: typeSale || 1,
  });


  // Effect to load product preview when selected
  useEffect(() => {
    if (productID && productID.value) {
      handleFetchProductPreview(productID);
    }
  }, [productID]);

  const handleFetchProductPreview = async (product) => {
    Swal.fire({
      title: 'Cargando datos del producto...',
      didOpen: () => {
        Swal.showLoading();
      },
      allowOutsideClick: false,
      showConfirmButton: false,
    });

    try {
      const productRes = await MethodGet(`/products/${product.value}`);
      const productData = productRes.data.data;

      // Business Rule: Use Sale's Discount
      const discount = details.discount || 0;
      const discountedPrice = Math.round(productData.price * (1 - discount / 100));

      setSelectedProductData(productData);
      setQuantityToAdd(1);
      setPriceToAdd(discountedPrice);

      Swal.close();
    } catch (error) {
      Swal.close();
      console.error(error);
      toast.error("Error al obtener datos del producto");
    }
  };

  const detectarCambiosTypeProduct = (value) => {
    setTypeProduct(value.value);
    setSelectedProductData(null); // Clear preview when changing type
  };

  const detectarCambiosTypeSale = (value) => {
    setTypeSale(value.value);
  };

  const handleBarcodeSearch = (e) => {
    e.preventDefault();
    if (!barcode) return;

    if (!productsList || productsList.length === 0) {
      toast.warning("Cargando productos...");
      return;
    }

    // Find product in productsList
    const product = productsList.find(p => p.tag === barcode);

    if (product) {
      handleFetchProductPreview({ value: product.id });
      setBarcode(""); // Clear input
    } else {
      toast.error("Producto no encontrado con ese código");
      setBarcode("");
    }
  };

  const handleAddProduct = async () => {
    if (!selectedProductData) return;

    // Show loading
    Swal.fire({
      title: 'Agregando producto...',
      didOpen: () => {
        Swal.showLoading();
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
    });

    try {
      // Validate Stock locally first using the preview data
      if (selectedProductData.quantity < quantityToAdd) {
        Swal.close();
        Swal.fire({
          icon: 'error',
          title: 'Sin Stock',
          text: `El producto ${selectedProductData.name} no tiene existencias suficientes. Stock actual: ${selectedProductData.quantity}`,
        });
        return;
      }

      const payload = {
        product_id: selectedProductData.id,
        quantity: quantityToAdd,
        final_price: priceToAdd, // Use the price from state which user might have edited
        type: selectedProductData.type
      };

      // Use the new endpoint
      await MethodPost(`/api/sale-details/${saleId}/add`, payload);

      Swal.close();
      toast.success("Producto agregado correctamente");
      setSelectedProductData(null); // Clear preview after success
      setR(!r); // Reload details
    } catch (error) {
      Swal.close();
      console.error(error);
      toast.error("Error al agregar producto");
    }
  };

  const handleUpdateProduct = async (newData, oldData) => {
    // Show loading
    Swal.fire({
      title: 'Actualizando...',
      didOpen: () => {
        Swal.showLoading();
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
    });

    try {
      const payload = {
        quantity: newData.quantity,
        final_price: newData.quantity * newData.price
      };

      // Use the new endpoint with PUT
      // Note: MethodPost usually handles POST, but we can try to use it or clienteAxios directly for PUT
      // The previous code used MethodPost with _method: PUT for FormData, but here json is fine?
      // Let's use clienteAxios.put explicitly to be sure.
      await clienteAxios.put(`/api/sale-details/${oldData.id}/update`, payload);

      Swal.close();
      toast.success("Producto actualizado");
      setR(!r);
    } catch (error) {
      Swal.close();
      console.error(error);
      toast.error("Error al actualizar");
    }
  };

  const handleDeleteProduct = async (oldData) => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: "El producto será eliminado de la venta y regresado al stock",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar'
    }).then(async (result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Eliminando...',
          didOpen: () => {
            Swal.showLoading();
          },
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
        });
        try {
          await clienteAxios.delete(`/api/sale-details/${oldData.id}/remove`);
          Swal.close();
          Swal.fire(
            'Eliminado!',
            'El producto ha sido eliminado.',
            'success'
          )
          setR(!r);
        } catch (error) {
          Swal.close();
          console.error(error);
          Swal.fire(
            'Error!',
            'No se pudo eliminar el producto.',
            'error'
          )
        }
      }
    })
  };

  const handleEditPayment = (payment) => {
    setPaymentToEdit(payment);
    setOpenEdit(true);
  };

  const handleCloseEdit = () => {
    setOpenEdit(false);
    setPaymentToEdit(null);
  };

  const updatePayment = (data, callback) => {
    const formData = new FormData();
    formData.append("amount", data.amount);
    formData.append("type", data.type); // "Efectivo", "Tarjeta", "Transferencia"

    // Add image if present
    if (data.image) {
      formData.append("image", data.image);
    }
    // Add reference if present
    if (data.reference) {
      formData.append("reference", data.reference);
    }

    // Use the standard payments endpoint
    let url = `/payments/${data.id}`;

    // Send as POST with _method: PUT to handle FormData (standard Laravel behavior)
    formData.append("_method", "PUT");

    MethodPost(url, formData, { headerConfig })
      .then((response) => {
        Swal.fire({
          title: "Pago Actualizado",
          icon: "success",
          timer: 3000,
          showConfirmButton: false
        });
        setR(!r); // Reload data
        handleCloseEdit();
        callback();
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response?.data?.error || "Error al actualizar el pago",
          icon: "error",
        });
        callback();
      });
  };
  const AddInPayment = (data) => {
    const formData = new FormData();
    formData.append("card_income", data.card_income);
    formData.append("cash_income", data.cash_income);
    formData.append("transfer_income", data.transfer_income);
    if (data.card_income > 0) {
      formData.append("image", data.image);
    }
    if (data.transfer_income > 0) {
      formData.append("reference", data.reference);
    }
    if (data.change > 0) {
      formData.append("change", data.change);
    }
    let url = `addPayments/${sales.id}`;
    MethodPost(url, formData, { headerConfig })
      .then((response) => {
        let folio = response.data.data.folio;
        let timerInterval;
        Swal.fire({
          title: "Pago Registrado",
          html: "El ticket se esta generando",
          icon: "success",
          timer: 3000,
          showConfirmButton: false,
          timerProgressBar: true,
          willClose: () => {
            clearInterval(timerInterval);
          },
        }).then((result) => {
          //Generar tiket de pago
          clienteAxios
            .get(`/ticketp/${sales.id}`, { responseType: "blob" })
            .then((response) => {
              let pdfname = "AbonoVenta" + folio + ".pdf";
              fileDownload(response.data, pdfname);
            })
            .catch((error) => {
              if (error.response.status === 409) {
                Swal.fire({
                  icon: "error",
                  title: "Error inesperado. Si persiste, contacta con el administrador",
                  text: "No cuentas con suficiente información para generar reporte",
                });
                return;
              } else if (error.response.status === 422) {
                console.log(error);
                return;
              }
              return;
            });
        });
        setR(true);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response.data.error,
          icon: "error",
        });
      });
  };
  const addPayment = (e) => {
    if (
      totalDescuento < informacionMetodoPago.amount &&
      informacionMetodoPago.cash_income < totalDescuento
    ) {
      toast.warn(
        <div>
          <ErrorIcon /> {"El monto no puede ser mayor al total a pagar"}
        </div>,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      return;
    } else if (informacionMetodoPago.amount < 0) {
      toast.warn(
        <div>
          <ErrorIcon /> {"No se permiten números negativos"}
        </div>,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      return;
    } else if (informacionMetodoPago.amount == 0) {
      toast.warn(
        <div>
          <ErrorIcon /> {"Completa correctamente los datos"}
        </div>,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      return;
    } else if (informacionMetodoPago.card_income > 0) {
      if (image.image == "") {
        toast.warn(
          <div>
            <ErrorIcon /> {"Selecciona ticket"}
          </div>,
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        return;
      }
    } else if (informacionMetodoPago.transfer_income > 0) {
      if (informacionMetodoPago.reference == "") {
        toast.warn(
          <div>
            <ErrorIcon /> {"Debes introducir una referencia válida"}
          </div>,
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
        return;
      }
    }
    setDisabledButton(true);
    data.id = saleId;
    data.cash_income = informacionMetodoPago.cash_income;
    data.card_income = informacionMetodoPago.card_income;
    data.transfer_income = informacionMetodoPago.transfer_income;
    data.image = image.image;
    data.change = informacionMetodoPago.change;
    data.reference = informacionMetodoPago.reference;
    data.invoice = informacionMetodoPago.invoice;
    AddInPayment(data);
    handleClose();
  };
  useEffect(() => {
    let url = `/details/${id}`;
    MethodGet(url)
      .then((res) => {
        saveDetail(res.data.details);
        saveSaleId(res.data.details.saleId);
        saveProducts(res.data.products);
        savePayments(res.data.payments);
        spinnerCargando(true);
      })
      .catch((error) => {
        console.log(error);
        spinnerCargando(true);
      });
  }, []);

  const handleClose = () => {
    guardarMetodoPago({
      amount: "",
      change: "0",
      cash_income: "0",
      card_income: "0",
      transfer_income: "0",
    });
    setOpen(false);
    setDisabledButton(false);
  };
  useEffect(() => {
    MethodGet(`/sales/${saleId}`)
      .then((res) => {
        saveSale(res.data.data)
        spinnerCargando(true);
      })
      .catch((error) => {
        console.log(error);
        spinnerCargando(true);
      });
  }, [saleId]);

  const subtotal = new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2,
  }).format(details.subtotal);

  const total = new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2,
  }).format(details.total);

  const infodiscount = new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2,
  }).format(details.subtotal - details.total);

  const [informacionMetodoPago, guardarMetodoPago] = useState({
    amount: "0",
    change: "0",
    cash_income: "0",
    card_income: "0",
    transfer_income: "0",
    reference: "",
    invoice: "",
  });
  const handleClickOpen = () => {
    setOpen(true);
  };
  const [currentSale, SaveCurrentSale] = useState(0);
  const [totalPagado, guardarTotalPagado] = useState(0);
  const [totalDescuento, guardarTotalDescuento] = useState(0);
  const SelectSalePayment = (saleId, total, total_paid) => {
    SaveCurrentSale(saleId);
    guardarTotalDescuento(total);
    guardarTotalPagado(total_paid);
    setOpen(true);
  };
  const obtenerInformacionPago = (e) => {
    guardarMetodoPago({
      ...informacionMetodoPago,
      [e.target.name]: e.target.value,
    });
  };
  const generarTicket = (id) => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "¿Desea Generar El Ticket De Gasto?",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, generar",
      cancelButtonText: "No, cancelar",
    }).then((result) => {
      if (result.value) {
        let timerInterval;
        Swal.fire({
          title: "Generando",
          html: "El ticket se está generando",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          willClose: () => {
            clearInterval(timerInterval);
          },
        })
        //Cunsume API de Back-end en laravel para generar tiket de venta
        clienteAxios
          .get(`/ticketpayment/${id}`, { responseType: "blob" })
          .then((response) => {
            fileDownload(response.data, "TicketPago " + id + ".pdf");
          })
          .catch((error) => {
            if (error.response.status === 409) {
              Swal.fire({
                icon: "error",
                title: "Error inesperado. Si persiste, contacta con el administrador",
                text: "No cuentas con suficiente información para generar reporte",
              });
            }
          });
      }
    });
  };
  //  spinner de carga
  if (!cargando) return <Spinner />;

  return (
    <LayoutDashboard>
      <Grid container>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          justify="center"
          style={{
            background: "linear-gradient(50deg, #6F33AB 33%, indigo 100%)",
            color: "white",
            marginTop: 80,
            borderRadius: 15,
            paddingLeft: 25,
            paddingRight: 25,
            marginBottom: 10,
          }}
        >
          <Typography
            component="h1"
            variant="h4"
            align="center"
            className={classes.typography}
          >
            Detalle de ventas
          </Typography>
        </Grid>
      </Grid>
      <Container>
        <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6} style={{ padding: 10 }}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography
                component="h1"
                variant="h4"
                align="center"
                className={classes.papercardtitle}
              >
                Información de venta
              </Typography>
            </Grid>
            <Paper className={classes.papercard}>
              <Grid item xs={12} sm={12} md={7} lg={7} xl={7} container style={{ marginLeft: 20 }}>
                <Grid item container xs={12} sm={12} md={12} lg={5} xl={5}>
                  <Typography component="h6" variant="h6">
                    Folio:
                  </Typography>
                  <Typography
                    component="h6"
                    variant="h6"
                    color="textSecondary"
                    alignItems="stretch"
                  >
                    {details.folio}
                  </Typography>
                </Grid>
                <Grid item container xs={12} sm={12} md={12} lg={7} xl={7}>
                  <Typography component="h6" variant="h6">
                    Fecha:
                  </Typography>
                  <Typography
                    component="h6"
                    variant="h6"
                    color="textSecondary"
                    alignItems="stretch"
                  >
                    {details.fechaventa}
                  </Typography>
                </Grid>
                <Grid item container>
                  <Typography component="h6" variant="h6">
                    Cantidad de Productos:
                  </Typography>
                  <Typography
                    component="h6"
                    variant="h6"
                    color="textSecondary"
                    alignItems="stretch"
                  >
                    {details.cantidad}
                  </Typography>
                </Grid>
                <Grid item container>
                  <Typography component="h6" variant="h6">
                    Subtotal:
                  </Typography>
                  <Typography
                    component="h6"
                    variant="h6"
                    color="textSecondary"
                    alignItems="stretch"
                  >
                    {subtotal}
                  </Typography>
                </Grid>
                <Grid item container>
                  <Grid
                    item
                    container
                    xs={10}
                    sm={10}
                    md={10}
                    lg={10}
                    xl={10}
                  >
                    <Typography component="h6" variant="h6">
                      Descuento:
                    </Typography>
                    <Typography
                      component="h6"
                      variant="h6"
                      color="textSecondary"
                      alignItems="stretch"
                    >
                      {infodiscount}
                    </Typography>
                  </Grid>
                  <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                    <Typography
                      component="h6"
                      variant="h6"
                      color="textSecondary"
                      style={{ color: "red" }}
                    >
                      {details.discount}%
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item container>
                  <Typography component="h6" variant="h6">
                    Total:
                  </Typography>
                  <Typography
                    component="h6"
                    variant="h6"
                    color="textSecondary"
                    alignItems="stretch"
                  >
                    {new Intl.NumberFormat("es-MX", {
                      style: "currency",
                      currency: "MXN",
                      minimumFractionDigits: 2,
                    }).format(details.total)}
                  </Typography>
                </Grid>
                <Grid item container>
                  <Typography component="h6" variant="h6">
                    Recibimos:
                  </Typography>
                  <Typography
                    component="h6"
                    variant="h6"
                    color="textSecondary"
                    alignItems="stretch"
                  >
                    {new Intl.NumberFormat("es-MX", {
                      style: "currency",
                      currency: "MXN",
                      minimumFractionDigits: 2,
                    }).format(sales.total_paid)}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          {/**
           ***** Tbl Datos del Cliente
           */}
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6} style={{ padding: 10 }}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography
                component="h1"
                variant="h4"
                align="center"
                className={classes.papercardtitle}
              >
                Datos del Cliente
              </Typography>
            </Grid>
            <Paper className={classes.papercard}>
              <Grid item xs={12} sm={12} md={7} lg={7} xl={7} container style={{ marginLeft: 20 }}>
                <Grid item container>
                  <Typography component="h6" variant="h6">
                    Nombre:
                  </Typography>
                  <Typography
                    component="h6"
                    variant="h6"
                    color="textSecondary"
                    alignItems="stretch"
                  >
                    {details.nombre_cliente} {details.apellidop_cliente}{" "}
                    {details.apellidomat_cliente}
                  </Typography>
                </Grid>
                <Grid item container>
                  <Typography component="h6" variant="h6">
                    Teléfono:
                  </Typography>
                  <Typography
                    component="h6"
                    variant="h6"
                    color="textSecondary"
                    alignItems="stretch"
                  >
                    {details.telefono_cliente
                      ? details.telefono_cliente
                      : `No registrado`}
                  </Typography>
                </Grid>
                <Grid item container>
                  <Typography component="h6" variant="h6">
                    RFC:
                  </Typography>
                  <Typography
                    component="h6"
                    variant="h6"
                    color="textSecondary"
                    alignItems="stretch"
                  >
                    {details.client_rfc
                      ? details.client_rfc
                      : `No registrado`}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
        {/**
         ***** Tbl Detalle de Productos
         */}

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography
              component="h1"
              variant="h4"
              align="center"
              className={classes.papercardtitle}
            >
              Detalle de compra del cliente
            </Typography>
          </Grid>

          {/* Admin Only: Select Product to Add - Refactored to Tailwind CSS */}
          {usuario?.type == 1 && (
            <div className="w-full my-5 relative z-40">
              <div className="p-4 bg-white shadow-lg rounded-lg border border-gray-200">
                <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-4">

                  {/* Label */}
                  <div className="w-full md:w-1/6">
                    <h6 className="text-lg font-semibold text-gray-800 mb-2 md:mb-0">Agregar Prod:</h6>
                  </div>

                  {/* Sale Type Selector (Mixtos/Wapizima/Extra) */}
                  <div className="w-full md:w-1/4">
                    <SelectTypeSale detectarCambiosTypeSale={detectarCambiosTypeSale} type_sale={typeSale} />
                  </div>

                  {/* Input Method Selector (Barcode/List) */}
                  <div className="w-full md:w-1/4">
                    <ChangeTypeSale detectarCambiosTypeProduct={detectarCambiosTypeProduct} />
                  </div>

                  {/* Input based on Type */}
                  <div className="w-full md:w-1/3">
                    {typeProduct === 1 && (
                      <form onSubmit={handleBarcodeSearch} className="w-full">
                        <TextField
                          fullWidth
                          variant="outlined"
                          size="small"
                          placeholder="Escanea y Enter"
                          value={barcode}
                          onChange={(e) => setBarcode(e.target.value)}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <CropFreeIcon />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </form>
                    )}
                    {typeProduct === 2 && (
                      <SelectProduct />
                    )}
                  </div>
                </div>

                {/* Explicit Addition Preview */}
                {selectedProductData && (
                  <div className="mt-6 p-4 bg-gray-50 rounded-lg border-2 border-dashed border-indigo-200 animate-in fade-in duration-300">
                    <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4">
                      <div>
                        <h5 className="text-xl font-bold text-indigo-700">{selectedProductData.name}</h5>
                        <p className="text-sm text-gray-500">Stock disponible: <span className="font-semibold text-gray-800">{selectedProductData.quantity}</span></p>
                      </div>
                      <div className="mt-2 md:mt-0 px-3 py-1 bg-indigo-100 text-indigo-700 rounded-full text-xs font-bold uppercase tracking-wider">
                        Previsualización
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <div className="flex flex-col">
                        <label className="text-xs font-bold text-gray-400 uppercase mb-1">Precio Unitario (Con Descto)</label>
                        <TextField
                          type="number"
                          variant="outlined"
                          size="small"
                          fullWidth
                          value={priceToAdd}
                          InputProps={{
                            readOnly: true,
                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                            className: "bg-gray-100"
                          }}
                        />
                      </div>
                      <div className="flex flex-col">
                        <label className="text-xs font-bold text-gray-400 uppercase mb-1">Cantidad</label>
                        <TextField
                          type="number"
                          variant="outlined"
                          size="small"
                          fullWidth
                          value={quantityToAdd}
                          onChange={(e) => setQuantityToAdd(Number(e.target.value))}
                          inputProps={{ min: 1 }}
                        />
                      </div>
                      <div className="flex flex-col">
                        <label className="text-xs font-bold text-gray-400 uppercase mb-1">Subtotal</label>
                        <div className="h-10 flex items-center px-3 bg-white border border-gray-300 rounded font-bold text-indigo-600">
                          {new Intl.NumberFormat("es-MX", {
                            style: "currency",
                            currency: "MXN",
                          }).format(priceToAdd * quantityToAdd)}
                        </div>
                      </div>
                    </div>

                    <div className="flex flex-row justify-end mt-6 space-x-3">
                      <button
                        onClick={() => setSelectedProductData(null)}
                        className="px-6 py-2 bg-white border border-gray-300 text-gray-700 font-semibold rounded-lg hover:bg-gray-50 transition-colors shadow-sm"
                      >
                        Cancelar
                      </button>
                      <button
                        onClick={handleAddProduct}
                        className="px-6 py-2 bg-indigo-600 text-white font-semibold rounded-lg hover:bg-indigo-700 transition-all shadow-md transform active:scale-95"
                      >
                        Guardar cambios
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          <Hidden only={["xs", "sm"]}>
            <MaterialTable
              title={""}
              columns={[
                { title: "Clave", field: "tag", editable: 'never' },
                { title: "Nombre", field: "name", editable: 'never' },
                { title: "Descripcion", field: "description", editable: 'never' },
                {
                  title: "Precio",
                  field: "price",
                  editable: 'never', // Assuming price comes from product and isn't editable per unit here, or maybe we allow it?
                  // The requirement said "Modifica la cantidad o precio".
                  // So I should allow editing price?
                  // "final_price" is calculated. 
                  // If I edit price, I should probably allow it.
                  // Let's check the columns again. 
                  // Field is "price". Render formats it.
                  render: (rowData) =>
                    new Intl.NumberFormat("es-MX", {
                      style: "currency",
                      currency: "MXN",
                      minimumFractionDigits: 0,
                    }).format(rowData.price),
                },
                { title: "Cantidad", field: "quantity", type: 'numeric' },
                {
                  title: "Tipo",
                  field: "tag",
                  editable: 'never',
                  render: (rowData) => (
                    <>
                      {rowData.type === 1
                        ? "Mixtos"
                        : rowData.type === 2
                          ? "Wapizima"
                          : rowData.type === 3
                            ? "Extra"
                            : "General"}
                    </>
                  ),
                },
              ]}
              data={products}
              editable={usuario?.type == 1 ? {
                onRowUpdate: (newData, oldData) =>
                  new Promise((resolve, reject) => {
                    handleUpdateProduct(newData, oldData);
                    resolve();
                  }),
                onRowDelete: (oldData) =>
                  new Promise((resolve, reject) => {
                    handleDeleteProduct(oldData);
                    resolve();
                  }),
              } : {}}
              options={{
                headerStyle: {
                  backgroundColor: "none",
                  color: "#000",
                  fontSize: "16px",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                },

                actionsColumnIndex: -1,
              }}
              localization={{
                pagination: {
                  labelDisplayedRows: "{from} - {to} de {count}",
                  labelRowsSelect: "Columnas",
                  firstTooltip: "Primera Pagina",
                  previousTooltip: "Anterior",
                  nextTooltip: "Siguiente",
                  lastTooltip: "Ultima Página",
                },
                toolbar: {
                  searchTooltip: "Buscar",
                  searchPlaceholder: "Buscar",
                },
                body: {
                  emptyDataSourceMessage: "No Hay Productos que Mostrar",
                  filterRow: {
                    filterTooltip: "Buscar",
                  },
                },
              }}
            />
          </Hidden>
          <Hidden only={["md", "lg", "xl"]}>
            <MaterialTable
              title={""}
              columns={[
                { title: "Clave", field: "tag", editable: 'never' },
                { title: "Nombre", field: "name", editable: 'never' },
                { title: "Cant.", field: "quantity", type: 'numeric' }, // Added Quantity for editing
              ]}
              data={products}
              editable={usuario?.type == 1 ? {
                onRowUpdate: (newData, oldData) =>
                  new Promise((resolve, reject) => {
                    handleUpdateProduct(newData, oldData);
                    resolve();
                  }),
                onRowDelete: (oldData) =>
                  new Promise((resolve, reject) => {
                    handleDeleteProduct(oldData);
                    resolve();
                  }),
              } : {}}
              options={{
                headerStyle: {
                  backgroundColor: "none",
                  color: "#000",
                  fontSize: "16px",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                },

                actionsColumnIndex: -1,
              }}
              detailPanel={[
                {
                  tooltip: "Show",
                  render: (rowData) => {
                    return (
                      <div
                        style={{
                          color: "black",
                          marginLeft: 50,
                        }}
                      >
                        <p>Descripcion: {rowData.description}</p>
                        <p>
                          Precio:{" "}
                          {new Intl.NumberFormat("es-MX", {
                            style: "currency",
                            currency: "MXN",
                            minimumFractionDigits: 0,
                          }).format(rowData.price)}
                        </p>
                        <p>Cantidad: {rowData.quantity}</p>
                        <p>
                          Tipo:{" "}
                          {
                            <>
                              {rowData.type === 1
                                ? "Mixtos"
                                : rowData.type === 2
                                  ? "Wapizima"
                                  : rowData.type === 3
                                    ? "Extra"
                                    : "General"}
                            </>
                          }
                        </p>
                      </div>
                    );
                  },
                },
              ]}
              localization={{
                pagination: {
                  labelDisplayedRows: "{from} - {to} de {count}",
                  labelRowsSelect: "Columnas",
                  firstTooltip: "Primera Pagina",
                  previousTooltip: "Anterior",
                  nextTooltip: "Siguiente",
                  lastTooltip: "Ultima Página",
                },
                toolbar: {
                  searchTooltip: "Buscar",
                  searchPlaceholder: "Buscar",
                },
                body: {
                  emptyDataSourceMessage: "No Hay Productos que Mostrar",
                  filterRow: {
                    filterTooltip: "Buscar",
                  },
                },
              }}
            />
          </Hidden>
        </Grid >
        {/**
         ***** Tbl Datos del Cliente
         */}

        < Grid container xs={12} sm={12} md={12} lg={12} xl={12} >
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            {sales.total > sales.total_paid ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography
                  component="h1"
                  variant="h4"
                  align="center"
                  className={classes.papercardtitle}
                >Pagos realizados
                </Typography>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  align="right"
                  style={{ marginRight: 30, marginTop: -30 }}
                >
                  <Button
                    variant="contained"
                    style={{ textTransform: "none", background: "white" }}
                    size="small"
                    type="submit"
                    onClick={() => {
                      SelectSalePayment(
                        sales.id,
                        sales.total,
                        sales.total_paid
                      )
                    }
                    }
                  >
                    <Tooltip title="Agregar Pago" aria-label="Agregar Pago">
                      <MonetizationOnIcon style={{ color: "indigo" }} />
                    </Tooltip>Realizar pago
                  </Button>
                </Grid>
              </Grid>
            ) : (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography
                  component="h1"
                  variant="h4"
                  align="center"
                  className={classes.papercardtitle}
                >Pagos realizados
                </Typography>

              </Grid>
            )}
            <Hidden only={["xs", "sm"]}>
              <MaterialTable
                title={""}
                columns={[
                  { title: "Fecha", field: "fecha" },
                  { title: "Tipo de Pago", field: "name" },
                  {
                    title: "Monto",
                    field: "amount",
                    render: (rowData) =>
                      new Intl.NumberFormat("es-MX", {
                        style: "currency",
                        currency: "MXN",
                        minimumFractionDigits: 0,
                      }).format(Number(rowData.amount - sales.change)),
                  },
                  {
                    title: "Referencia",
                    field: "reference",
                    render: (rowData) => (
                      <>{rowData.reference ? rowData.reference : `No Aplica`}</>
                    ),
                  },
                  {
                    title: "Opciones",
                    field: "generarTicket",
                    render: (rowData) => (
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <Button
                          style={{ textTransform: "none" }}
                          size="small"
                          onClick={() => handleEditPayment(rowData)}
                        >
                          <Tooltip title="Editar pago" aria-label="Editar pago">
                            <EditIcon style={{ color: "blue" }} />
                          </Tooltip>
                        </Button>
                        <Button
                          style={{ textTransform: "none" }}
                          size="small"
                          onClick={() => generarTicket(rowData.id)}
                        >
                          <Tooltip
                            title="Generar ticket de venta"
                            aria-label="Generar ticket de venta"
                          >
                            <PictureAsPdf style={{ color: "rgb(0, 0, 0)" }} />
                          </Tooltip>
                        </Button>
                      </div>
                    ),
                  },
                ]}
                data={payments}
                options={{
                  headerStyle: {
                    backgroundColor: "none",
                    color: "#000",
                    fontSize: "16px",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                  },
                  actionsColumnIndex: -1,
                }}
                localization={{
                  pagination: {
                    labelDisplayedRows: "{from} - {to} de {count}",
                    labelRowsSelect: "Columnas",
                    firstTooltip: "Primera Pagina",
                    previousTooltip: "Anterior",
                    nextTooltip: "Siguiente",
                    lastTooltip: "Ultima Página",
                  },
                  toolbar: {
                    searchTooltip: "Buscar",
                    searchPlaceholder: "Buscar",
                  },
                  body: {
                    emptyDataSourceMessage: "No Hay Productos que Mostrar",
                    filterRow: {
                      filterTooltip: "Buscar",
                    },
                  },
                }}
              />
            </Hidden>
            <Hidden only={["md", "lg", "xl"]}>
              <MaterialTable
                title={""}
                columns={[
                  { title: "Fecha", field: "fecha" },
                  { title: "Tipo de Pago", field: "name" },
                  {
                    title: "Monto",
                    field: "amount",
                    render: (rowData) =>
                      new Intl.NumberFormat("es-MX", {
                        style: "currency",
                        currency: "MXN",
                        minimumFractionDigits: 0,
                      }).format(rowData.amount),
                  },
                  {
                    title: "Referencia",
                    field: "reference",
                    render: (rowData) => (
                      <>{rowData.reference ? rowData.reference : `No Aplica`}</>
                    ),
                  },
                  {
                    title: "Opciones",
                    field: "generarTicket",
                    render: (rowData) => (
                      <div style={{ display: "flex", justifyContent: "center" }}>
                        <Button
                          style={{ textTransform: "none" }}
                          size="small"
                          onClick={() => handleEditPayment(rowData)}
                        >
                          <Tooltip title="Editar pago" aria-label="Editar pago">
                            <EditIcon style={{ color: "blue" }} />
                          </Tooltip>
                        </Button>
                        <Button
                          style={{ textTransform: "none" }}
                          size="small"
                          onClick={() => generarTicket(rowData.id)}
                        >
                          <Tooltip
                            title="Generar ticket de venta"
                            aria-label="Generar ticket de venta"
                          >
                            <PictureAsPdf style={{ color: "rgb(0, 0, 0)" }} />
                          </Tooltip>
                        </Button>
                      </div>
                    ),
                  },
                ]}
                data={payments}
                options={{
                  headerStyle: {
                    backgroundColor: "none",
                    color: "#000",
                    fontSize: "16px",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                  },

                  actionsColumnIndex: -1,
                }}
                detailPanel={[
                  {
                    tooltip: "Show",
                    render: (rowData) => {
                      return (
                        <div
                          style={{
                            color: "black",
                            marginLeft: 50,
                          }}
                        >
                          <p>
                            Monto:{" "}
                            {new Intl.NumberFormat("es-MX", {
                              style: "currency",
                              currency: "MXN",
                              minimumFractionDigits: 0,
                            }).format(rowData.amount)}
                          </p>
                          <p>
                            Referencia:{" "}
                            {
                              <>
                                {rowData.reference
                                  ? rowData.reference
                                  : `No Aplica`}
                              </>
                            }
                          </p>
                        </div>
                      );
                    },
                  },
                ]}
                localization={{
                  pagination: {
                    labelDisplayedRows: "{from} - {to} de {count}",
                    labelRowsSelect: "Columnas",
                    firstTooltip: "Primera Pagina",
                    previousTooltip: "Anterior",
                    nextTooltip: "Siguiente",
                    lastTooltip: "Ultima Página",
                  },
                  toolbar: {
                    searchTooltip: "Buscar",
                    searchPlaceholder: "Buscar",
                  },
                  body: {
                    emptyDataSourceMessage: "No Hay Productos que Mostrar",
                    filterRow: {
                      filterTooltip: "Buscar",
                    },
                  },
                }}
              />
            </Hidden>
          </Grid>
        </Grid >

        <Grid container xs={12} sm={12} md={12} lg={12} xl={12} spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography
                component="h1"
                variant="h4"
                align="center"
                className={classes.papercardtitle}
              >
                Ticket de Compra
              </Typography>
            </Grid>
            <Paper className={classes.Tblpapercard}>
              <Grid container>
                {payments.map((payment) => (
                  <Grid
                    container
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    key={payment.id}
                    direction="row"
                    justify="space-around"
                    alignItems="center"
                  >
                    <Grid item container xs={12} sm={12} md={6} lg={6} xl={6}>
                      <Grid item>
                        <Typography component="h5" variant="h5">
                          {payment.name}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <Grid item>
                        <Typography component="h5" variant="h5">
                          {payment.ticket ? (
                            <ButtonBase className={classes.ticketimage}>
                              <ModalImage
                                small={payment.ticket}
                                large={payment.ticket}
                                alt="ticket"
                                className={classes.img}
                              />
                            </ButtonBase>
                          ) : payment.ticketTransfer ? (
                            <ButtonBase className={classes.ticketimage}>
                              <ModalImage
                                small={payment.ticketTransfer}
                                large={payment.ticketTransfer}
                                alt="ticketTransfer"
                                className={classes.img}
                              />
                            </ButtonBase>
                          ) : (
                            `No Aplica`
                          )}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Container >
      <ModalPayments
        open={open}
        setOpen={setOpen}
        handleClickOpen={handleClickOpen}
        handleClose={handleClose}
        totalDescuento={totalDescuento}
        totalPagado={totalPagado}
        informacionMetodoPago={informacionMetodoPago}
        image={image}
        obtenerInformacionPago={obtenerInformacionPago}
        addPayment={addPayment}
        handleChangeImage={handleChangeImage}
        disableButton={disableButton}
      />
      <ModalEditPayment
        open={openEdit}
        handleClose={handleCloseEdit}
        payment={paymentToEdit}
        updatePayment={updatePayment}
      />
    </LayoutDashboard >
  );
}
